import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      members: {},
      moments: {},
      requesting: false,
      teamInviteCard: {},
      teamReferrer: {},
      stat: {},
      history: {}
    };
  },
  mutations: {
    setMembers: function setMembers(state, _a) {
      var teamId = _a.teamId,
          members = _a.members;
      Vue.set(state.members, teamId, members);
    },
    setRequesting: function setRequesting(state, requesting) {
      state.requesting = requesting;
    },
    setTeamInviteCardMap: function setTeamInviteCardMap(state, _a) {
      var teamId = _a.teamId,
          card = _a.card;
      Vue.set(state.teamInviteCard, teamId, card);
    },
    setTeamReferrer: function setTeamReferrer(state, _a) {
      var key = _a.key,
          data = _a.data;
      Vue.set(state.teamInviteCard, key, data);
    },

    /** 记录统计数据 */
    setStat: function setStat(state, _a) {
      var teamId = _a.teamId,
          stat = _a.stat;
      Vue.set(state.stat, teamId, stat);
    },
    setHistory: function setHistory(state, _a) {
      var teamId = _a.teamId,
          history = _a.history;
      Vue.set(state.history, teamId, history);
    }
  },
  actions: {
    /**
     * 获取战队成员列表
     *
     * @param {number} teamId
     *
     * @return {Object} rdata
     *  - status 0表示成功，-1表示失败
     *  - message 失败信息
     */
    getTeamMembers: function getTeamMembers(context, _a) {
      var teamId = _a.teamId,
          forceUpdate = _a.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/team_members', {
                params: {
                  id: teamId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setMembers', {
                  teamId: teamId,
                  members: rdata.data
                });
              }

              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 获得战队邀请卡
     *
     * @param {string} activityId
     * @param {number} teamId 战队id
     */
    getTeamInviteCard: function getTeamInviteCard(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var temp, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              temp = state.teamInviteCard[teamId];

              if (temp && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/get_team_invite_card_sync', {
                params: {
                  activity_id: activityId,
                  team_id: teamId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setTeamInviteCardMap', {
                  // activityId,
                  teamId: teamId,
                  card: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 记录战队详情页面的访问情况
     *
     * @param {string} referrer
     * @param {number} teamId 战队id
     */
    recordTeam: function recordTeam(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var referrer = _b.referrer,
          teamId = _b.teamId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var key, temp, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              key = referrer + '_' + teamId;
              temp = state.teamReferrer[key];

              if (temp && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/activity/team_visit', {
                referrer: referrer,
                team_id: teamId
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setTeamReferrer', {
                  key: key,
                  data: ''
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得统计数据
     */
    getStat: function getStat(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var teamId = _b.teamId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var promise, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.stat[teamId] && !forceUpdate) {
                return [2
                /*return*/
                , state.stat[teamId]];
              }

              promise = Vue.axios.get('/api/v1/activity/team_statistics', {
                params: {
                  id: teamId
                }
              });
              commit('setStat', {
                teamId: teamId,
                stat: promise
              });
              return [4
              /*yield*/
              , promise];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setStat', {
                  teamId: teamId,
                  stat: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得统计数据
     */
    getHistory: function getHistory(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var teamId = _b.teamId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.history[teamId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/history', {
                params: {
                  id: teamId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setHistory', {
                  teamId: teamId,
                  history: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;